import React from 'react';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  StaticPageHeader,
  NamedLink,
} from '../../components';

import css from './HowItWorksPage.module.css';

const HowItWorksPage = () => {
  return (
    <StaticPage
      title="How it works"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'HowItWorksPage',
        description: 'How PictureHum works',
        name: 'HowItWorks',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="HowItWorksPage" />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain>
          <StaticPageHeader
            title={
              <span>
                How does PictureHum
                <br />
                work
              </span>
            }
            activePage={3}
          />
          <div className={css.staticPageWrapper}>
            <div className={css.contentWrapper}>
              <div className={css.contentSide}>
                <h4 className={css.contentSideTitle}>Helpful links</h4>
                <ul className={css.contentSideList}>
                  <li>
                    <NamedLink
                      className={css.contentSideLink}
                      name="SearchPage"
                      to={{
                        search: '?pub_category=photographer',
                      }}
                    >
                      Photographers
                    </NamedLink>
                  </li>
                  <li>
                    <NamedLink
                      className={css.contentSideLink}
                      name="SearchPage"
                      to={{
                        search: '?pub_category=mini_session',
                      }}
                    >
                      Mini sessions
                    </NamedLink>
                  </li>
                </ul>
              </div>
              <div className={css.contentMain}>
                <h3 className={css.pageTitle}>How it works</h3>

                <p>
                  Creating high quality, lasting photographs shouldn't be a hassle. We also think
                  the barrier to entry for photographers is too challenging. That's why we created
                  PictureHum as a way for photographers and clients to connect with one another.
                </p>

                <ul className={css.list}>
                  <li>
                    1. <b>Find a photographer:</b> Enter the location where you would like to have a
                    photoshoot. Search and book a local photographer that fits your style and budget
                    and your friends have recommended. Photoshoots need to be paid in full in order
                    to schedule a photoshoot.
                  </li>
                  <li>
                    2. <b>Have your photoshoot:</b> Select a date, time, and location that works
                    with your chosen photographer and they will confirm. This is a good time to ask
                    your photographer any questions you might have (outfits, exact location, etc.).
                    Meet your photographer at the location during the date and time you've agreed
                    upon and enjoy your one hour photoshoot.
                  </li>
                  <li>
                    3. <b>Receive and download your images:</b> Images are delivered as edited
                    digital files in a password protected online gallery within 5 days of the
                    photoshoot. You can download all the images as well as order prints and other
                    photo memories through this service.
                  </li>
                </ul>

                <h3 className={css.pageTitle}>For Clients</h3>

                <p>
                  We know how hard it is to find a vetted photographer, as well as how complicated
                  pricing for photography can be. That's why we decided to fix these two problems by
                  creating a one stop source where friends can recommend quality photographers with
                  a simple and upfront pricing system.
                </p>

                <p>
                  The price you see on each photographer listing includes a one hour session with
                  over 30 digital images you can do whatever you want with. Share on social media,
                  print, make a photo book, or create holiday cards - they are yours!
                </p>

                <h3 className={css.pageTitle}>For Photographers</h3>

                <p>
                  We know how challenging it can be to run a business and market oneself while
                  simultaneously creating and editing really great photographs. PictureHum takes
                  care of the business side of your photography profession while also allowing you
                  maintain your independence as a photographer by setting your price and
                  availability. Whether you are a seasoned photographer with established clients
                  looking to fill open slots or a photographer looking to build a larger client
                  base, the PictureHum marketplace does the marketing so you don’t have to.
                </p>
              </div>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default HowItWorksPage;
